import { memo } from "react";
import type { GridRowParams } from "@mui/x-data-grid";
import { MenuItem } from "consts/openBanking";
import { useIbanXSBanksCountriesPivotActions } from "features/openBanking/actions";
import { DeleteOpenBankingResource } from "../../shared/OpenBankingResource";

const DeleteIbanXSBanksCountriesPivot = (props: GridRowParams) => {
    const { deleteIbanXSBanksCountriesPivot } = useIbanXSBanksCountriesPivotActions();

    const deleteOpenBankingResource = async ({ row }: GridRowParams) => {
        const [request] = deleteIbanXSBanksCountriesPivot(row, {
            shouldNotifyOnSuccess: true
        });
        await request;
    };

    return (
        <DeleteOpenBankingResource
            {...props}
            menuItem={MenuItem.IbanXSBanksCountriesPivot}
            deleteOpenBankingResource={deleteOpenBankingResource}
            ModalProps={{
                titleSlot: `Delete ID=${props.row.coreId} Iban XS Banks Countries Pivot`,
            }}
        >
            Are you sure you want to delete this Iban XS Banks Countries Pivot?
        </DeleteOpenBankingResource>
    );
};

export default memo(DeleteIbanXSBanksCountriesPivot);
